import { useState, useEffect } from "react";
import api from "../../services/api";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { TIPOS_DATO } from "../dynamicsFields/fieldTypes";

// Efecto visual para inputs y selects al recibir foco
if (typeof window !== 'undefined' && !document.getElementById('rulebuilder-glow-style')) {
  const style = document.createElement('style');
  style.id = 'rulebuilder-glow-style';
  style.innerHTML = `
    .rulebuilder-glow:focus {
      box-shadow: 0 0 0 2px #ffd700, 0 0 8px #ffd70099;
      border-color: #ffd700;
      outline: none;
      transition: box-shadow 0.2s, border-color 0.2s;
    }
  `;
  document.head.appendChild(style);
}
const RuleBuilder = ({ idPatologia, editingRule, onSave, onCancel, idPersona }) => {
    // Relaciones reales de la persona (por persona)
    const [relacionesPersona, setRelacionesPersona] = useState([]);
    // Tipos de relación globales (de la tabla tiporelacion)
    const [tiposRelacion, setTiposRelacion] = useState([]);

    // Cargar relaciones reales y tipos de relación
    useEffect(() => {
      const fetchRelaciones = async () => {
        if (!idPersona) return;
        try {
          const resp = await api.get(`/relaciones/${idPersona}`);
          if (Array.isArray(resp.data)) {
            setRelacionesPersona(
              resp.data.map(rel => ({
                id: rel.idRelaciones,
                Nombre: `${rel.tipoRelacion} del caso ${rel.personaRelacionada ? rel.personaRelacionada.nombre + ' ' + rel.personaRelacionada.apellido : ''}`.trim()
              }))
            );
          } else {
            setRelacionesPersona([]);
          }
        } catch (err) {
          setRelacionesPersona([]);
        }
      };
      fetchRelaciones();
    }, [idPersona]);

    // Cargar tipos de relación globales (solo una vez)
    useEffect(() => {
      const fetchTiposRelacion = async () => {
        try {
          const resp = await api.get('/tiposRelacion');
          console.log('Datos recibidos de /tiposRelacion:', resp.data);
          if (Array.isArray(resp.data)) {
            // Mostrar la estructura real de cada elemento
            resp.data.forEach((item, idx) => {
              console.log(`tiposRelacion[${idx}]:`, item);
            });
            setTiposRelacion(resp.data);
          } else {
            setTiposRelacion([]);
          }
        } catch (err) {
          console.error('Error al obtener tiposRelacion:', err);
          setTiposRelacion([]);
        }
      };
      fetchTiposRelacion();
    }, []);
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [condiciones, setCondiciones] = useState([]);
  
  // Datos parametrizados disponibles
  const [sintomas, setSintomas] = useState([]);
  const [estudios, setEstudios] = useState([]);
  const [medicaciones, setMedicaciones] = useState([]);
  const [vacunas, setVacunas] = useState([]);
  // NUEVO: para nuevas categorías
  const [comorbilidades, setComorbilidades] = useState([]);
  const [atributos, setAtributos] = useState([]);

  useEffect(() => {
    cargarDatosParametrizados();

    if (editingRule) {
      setNombre(editingRule.Nombre || "");
      setDescripcion(editingRule.Descripcion || "");
      // --- Asegurar que Json_Definicion sea objeto ---
      let definicion = editingRule.Json_Definicion;
      if (typeof definicion === "string") {
        try { definicion = JSON.parse(definicion); } catch {}
      }
      setMensaje(definicion?.mensaje || "");

      // Cargar las condiciones desde el JSON
      if (definicion?.condiciones) {
        // Restaurar el campo original para edición, soportando campos simples como 'talla' y 'peso'
        const extraerCampo = (campo, campoOriginal, categoria) => {
          if (campoOriginal) return campoOriginal;
          // Para que el backend lo evalúe correctamente, debe ser datosAntropometricos.talla o datosAntropometricos.peso
          if (categoria === 'talle') return 'datosAntropometricos.talla';
          if (categoria === 'peso') return 'datosAntropometricos.peso';
          if (typeof campo === 'string' && campo.includes('.')) return campo;
          return campo;
        };
        const condicionesParaEditar = definicion.condiciones.map(cond => {
          if (cond.tipo === "grupo") {
            return {
              ...cond,
              condiciones: cond.condiciones.map(sub => ({
                ...sub,
                campo: extraerCampo(sub.campo, sub.campoOriginal, sub.categoria)
              }))
            };
          } else {
            return {
              ...cond,
              campo: extraerCampo(cond.campo, cond.campoOriginal, cond.categoria)
            };
          }
        });
        setCondiciones(condicionesParaEditar);
      }
    }
  }, [editingRule, idPatologia]);

  const cargarDatosParametrizados = async () => {
    try {
      // Cargar síntomas por patología
      const resSintomas = await api.get(`/sintomasporpatologia/${idPatologia}`);
      setSintomas(resSintomas.data || []);

      // Cargar estudios por patología
      const resEstudios = await api.get(`/estudios-patologia/${idPatologia}`);
      setEstudios(resEstudios.data || []);

      // Cargar medicaciones por patología - filtrar en cliente
      const resMedicaciones = await api.get(`/medicaciones-por-patologia`);
      const medicacionesFiltradas = (resMedicaciones.data || []).filter(
        m => m.IdPatologia == idPatologia && m.estado === 1
      );
      setMedicaciones(medicacionesFiltradas);

      // Cargar vacunas por patología - filtrar en cliente
      const resVacunas = await api.get(`/vacunas-por-patologia`);
      const vacunasFiltradas = (resVacunas.data || []).filter(
        v => v.IdPatologia == idPatologia && v.estado === 1
      );
      setVacunas(vacunasFiltradas);

      // NUEVO: cargar comorbilidades y atributos personales
      const resComorbilidades = await api.get(`/comorbilidades/${idPatologia}`);
        // Guardar todas las comorbilidades, el filtrado se hace en obtenerCamposPorCategoria
        setComorbilidades(resComorbilidades.data || []);
      const resAtributos = await api.get(`/atributosPorPatologia/${idPatologia}`);
      setAtributos((resAtributos.data || []).filter(a => a.estado === 1));
    } catch (error) {
      console.error("Error al cargar datos parametrizados:", error);
    }
  };

  const agregarCondicion = () => {
    setCondiciones([
      ...condiciones,
      {
        id: Date.now(),
        tipo: "condicion",
        categoria: "sintoma",
        campo: "",
        operador: "==",
        valor: "",
        operadorLogico: "AND",
      },
    ]);
  };

  const agregarGrupoCondiciones = () => {
    setCondiciones([
      ...condiciones,
      {
        id: Date.now(),
        tipo: "grupo",
        operadorLogico: "AND",
        condiciones: [
          {
            id: Date.now() + 1,
            tipo: "condicion",
            categoria: "sintoma",
            campo: "",
            operador: "==",
            valor: "",
            operadorLogico: "AND",
          },
        ],
      },
    ]);
  };

  const eliminarCondicion = (id, parentId = null) => {
    if (parentId) {
      // Eliminar condición dentro de un grupo
      setCondiciones(
        condiciones.map((c) => {
          if (c.id === parentId && c.tipo === "grupo") {
            return {
              ...c,
              condiciones: c.condiciones.filter((cond) => cond.id !== id)
            };
          }
          return c;
        })
      );
    } else {
      // Eliminar condición de nivel superior
      setCondiciones(condiciones.filter((c) => c.id !== id));
    }
  };

  const actualizarCondicion = (id, campo, valor, parentId = null) => {
    console.log("Actualizando condición:", { id, campo, valor, parentId });
    
    setCondiciones((prevCondiciones) => {
      if (parentId) {
        // Actualizar condición dentro de un grupo
        return prevCondiciones.map((c) => {
          if (c.id === parentId && c.tipo === "grupo") {
            return {
              ...c,
              condiciones: c.condiciones.map((sub) =>
                sub.id === id ? { ...sub, [campo]: valor } : sub
              ),
            };
          }
          return c;
        });
      } else {
        // Actualizar condición de nivel superior
        return prevCondiciones.map((c) => 
          c.id === id ? { ...c, [campo]: valor } : c
        );
      }
    });
  };

  const agregarCondicionAGrupo = (grupoId) => {
    setCondiciones(
      condiciones.map((c) => {
        if (c.id === grupoId && c.tipo === "grupo") {
          return {
            ...c,
            condiciones: [
              ...c.condiciones,
              {
                id: Date.now(),
                tipo: "condicion",
                categoria: "sintoma",
                campo: "",
                operador: "==",
                valor: "",
                operadorLogico: "AND",
              },
            ],
          };
        }
        return c;
      })
    );
  };

  const obtenerCamposPorCategoria = (categoria) => {
    switch (categoria) {
      case "sintoma":
        return Array.isArray(sintomas) ? sintomas.filter(s => s.estado === 1) : [];
      case "estudio":
        // Usar estadoRelacion para estudios por patología
        return Array.isArray(estudios) ? estudios.filter(e => e.estadoRelacion === 1) : [];
      case "medicacion":
        return medicaciones;
      case "vacuna":
        return vacunas;
      case "comorbilidad":
        // Permitir compatibilidad: si viene estadoRelacion, usarlo; si no, usar estado
        return Array.isArray(comorbilidades)
          ? comorbilidades.filter(c => (typeof c.estadoRelacion !== 'undefined' ? Number(c.estadoRelacion) === 1 : Number(c.estado) === 1))
          : [];
      case "atributo":
        return atributos;
      case "talle":
        return [{ id: "talla", Nombre: "Talla (cm)" }];
      case "peso":
        return [{ id: "peso", Nombre: "Peso (kg)" }];
      case "conviviente":
        return [
          { id: "si", Nombre: "Sí" },
          { id: "no", Nombre: "No" },
        ];
      case "relacion":
        return tiposRelacion.map(t => ({
          id: t.id || t.IdTipoRelacion,
          Nombre: t.Nombre || t.nombre || t.NombreRelacion || t.Descripcion || t.descripcion || t.Tipo || t.tipo || "(Sin nombre)"
        }));
      case "genero":
        return [
          { id: "Desconocido", Nombre: "Desconocido" },
          { id: "Mujer cis", Nombre: "Mujer cis" },
          { id: "Mujer trans", Nombre: "Mujer trans" },
          { id: "Varón cis", Nombre: "Varón cis" },
          { id: "Varón trans", Nombre: "Varón trans" },
          { id: "Otro", Nombre: "Otro" },
        ];
      default:
        return [];
    }
  };

  const obtenerTipoDato = (categoria, campoId) => {
    if (categoria === 'talle' || categoria === 'peso') {
      return TIPOS_DATO.NUMERICO;
    }
    const campos = obtenerCamposPorCategoria(categoria);
    const campo = campos.find((c) => {
      switch (categoria) {
        case "sintoma":
          return c.IdSintomaPorPatologia == campoId;
        case "estudio":
          return c.IdEstudio == campoId;
        case "medicacion":
          return c.IdMedicacionPorPatologia == campoId;
        case "vacuna":
          return c.IdVacunacionPorPatologia == campoId;
        default:
          return c.id == campoId;
      }
    });

    const parseJsonDefinicion = (raw) => {
      if (!raw) return null;
      if (typeof raw === "string") {
        try {
          return JSON.parse(raw);
        } catch {
          return null;
        }
      }
      if (typeof raw === "object") {
        return raw;
      }
      return null;
    };

    const nombreCampo = (campo?.NombreSintoma || campo?.Nombre || "").toString().toLowerCase();
    // Ajuste de negocio: fiebre/temperatura deben evaluarse como numérico.
    if (categoria === "sintoma" && (nombreCampo.includes("fiebre") || nombreCampo.includes("temperatura"))) {
      return TIPOS_DATO.NUMERICO;
    }

    // Si el campo tiene json_definicion como string, parsear
    let tipo = TIPOS_DATO.TEXTO;
    if (campo) {
      const definicion = parseJsonDefinicion(campo.json_definicion);
      const tipoDefinido = definicion?.tipo;
      tipo = typeof tipoDefinido === "string" && tipoDefinido.trim()
        ? tipoDefinido.trim().toLowerCase()
        : TIPOS_DATO.TEXTO;
    }
    return tipo;
  };

  const obtenerOperadoresPorTipo = (tipo) => {
    // Siempre se muestran todos los operadores sin distinción de tipo de dato. (pedido por martin)
    // Si se necesita volver al comportamiento anterior (restringir por tipo), descomentar el bloque de abajo y eliminar el return actual.
    /*
    switch (tipo) {
      case TIPOS_DATO.NUMERICO:
        return [
          { value: "==", label: "=" },
          { value: "!=", label: "≠" },
          { value: ">", label: ">" },
          { value: "<", label: "<" },
          { value: ">=", label: "≥" },
          { value: "<=", label: "≤" },
        ];
      case TIPOS_DATO.BOOLEANO:
        return [
          { value: "==", label: "=" },
          { value: "!=", label: "≠" },
        ];
      case TIPOS_DATO.TEXTO:
        return [
          { value: "==", label: "=" },
          { value: "!=", label: "≠" },
        ];
      case TIPOS_DATO.SELECCION:
      case TIPOS_DATO.MULTIPLE:
        return [
          { value: "==", label: "=" },
          { value: "!=", label: "≠" },
        ];
      case TIPOS_DATO.FECHA:
        return [
          { value: "==", label: "=" },
          { value: "!=", label: "≠" },
          { value: ">", label: "Después de" },
          { value: "<", label: "Antes de" },
          { value: ">=", label: "Desde" },
          { value: "<=", label: "Hasta" },
        ];
      default:
        return [
          { value: "==", label: "=" },
          { value: "!=", label: "≠" },
        ];
    }
    */
    return [
      { value: "==", label: "=" },
      { value: "!=", label: "≠" },
      { value: ">", label: ">" },
      { value: "<", label: "<" },
      { value: ">=", label: "≥" },
      { value: "<=", label: "≤" },
    ];
  };

  const renderInputValor = (condicion, parentId = null) => {
    if (!condicion.categoria || !condicion.campo) {
      return (
        <input
          type="text"
          className="input is-small"
          placeholder="Seleccione un campo primero"
          disabled
        />
      );
    }

    const tipo = obtenerTipoDato(condicion.categoria, condicion.campo);
    const campos = obtenerCamposPorCategoria(condicion.categoria);
    const campo = campos.find((c) => {
      switch (condicion.categoria) {
        case "sintoma":
          return c.IdSintomaPorPatologia == condicion.campo;
        case "estudio":
          return c.IdEstudio == condicion.campo;
        case "medicacion":
          return c.IdMedicacionPorPatologia == condicion.campo;
        case "vacuna":
          return c.IdVacunacionPorPatologia == condicion.campo;
        default:
          return c.id == condicion.campo;
      }
    });

    // Unificar lógica para tipos de datos avanzados en síntomas, estudios, medicaciones y vacunas
    // Detectar si el campo tiene json_definicion y usar su tipo/configuración
    const campoData = campo;

    // Si el campo tiene json_definicion, usar su tipo y configuración
    let tipoDato = tipo;
    let configCampo = null;
    if (campoData && campoData.json_definicion) {
      let definicion = campoData.json_definicion;
      if (typeof definicion === "string") {
        try {
          definicion = JSON.parse(definicion);
        } catch {
          definicion = null;
        }
      }

      if (definicion && typeof definicion === "object") {
        const tipoDefinido = typeof definicion.tipo === "string" ? definicion.tipo.trim().toLowerCase() : null;
        if (tipoDefinido) {
          tipoDato = tipoDefinido;
        }
        configCampo = definicion.configuracion || null;
      }
    }

    const nombreCampo = (campoData?.NombreSintoma || campoData?.Nombre || "").toString().toLowerCase();
    if (condicion.categoria === "sintoma" && (nombreCampo.includes("fiebre") || nombreCampo.includes("temperatura"))) {
      tipoDato = TIPOS_DATO.NUMERICO;
    }

    // Adaptar input según tipo de dato avanzado
    if ((tipoDato === TIPOS_DATO.SELECCION || tipoDato === TIPOS_DATO.MULTIPLE) && configCampo?.opciones?.length > 0) {
      if (tipoDato === TIPOS_DATO.MULTIPLE) {
        return (
          <div>
            <div className="select is-small" style={{ width: '100%' }}>
              <select
                className="rulebuilder-glow"
                multiple
                value={Array.isArray(condicion.valor) ? condicion.valor : (condicion.valor ? [condicion.valor] : [])}
                onChange={(e) => {
                  const selected = Array.from(e.target.selectedOptions, option => option.value);
                  actualizarCondicion(condicion.id, "valor", selected, parentId);
                }}
                style={{ minHeight: '70px', width: '100%' }}
              >
                {configCampo.opciones.map((op, idx) => (
                  <option key={idx} value={op}>{op}</option>
                ))}
              </select>
            </div>
            <div style={{ marginTop: 4 }}>
              <span className="tag is-info is-light" style={{ fontSize: '0.85em' }}>
                Tipo de dato sugerido: <strong style={{ marginLeft: 4 }}>Selección múltiple</strong>
              </span>
            </div>
          </div>
        );
      } else {
        return (
          <div>
            <div className="select is-small">
              <select
                className="rulebuilder-glow"
                value={condicion.valor}
                onChange={(e) => actualizarCondicion(condicion.id, "valor", e.target.value, parentId)}
              >
                <option value="">Seleccione...</option>
                {configCampo.opciones.map((op, idx) => (
                  <option key={idx} value={op}>{op}</option>
                ))}
              </select>
            </div>
            <div style={{ marginTop: 4 }}>
              <span className="tag is-info is-light" style={{ fontSize: '0.85em' }}>
                Tipo de dato sugerido: <strong style={{ marginLeft: 4 }}>Selección</strong>
              </span>
            </div>
          </div>
        );
      }
    } else if (tipoDato === TIPOS_DATO.COMPUESTO && configCampo?.subcampos?.length > 0) {
      const valorCompuesto = typeof condicion.valor === 'object' && condicion.valor !== null ? condicion.valor : {};
      const subcampos = configCampo.subcampos;
      const handleSubcampoChange = (etiqueta, value) => {
        const nuevoValor = {
          ...valorCompuesto,
          [etiqueta]: value
        };
        actualizarCondicion(condicion.id, "valor", nuevoValor, parentId);
      };
      return (
        <div>
          {subcampos.map((subcampo, idx) => {
            const subcampoValue = valorCompuesto[subcampo.etiqueta] || '';
            let inputType = 'text';
            if (subcampo.tipo === 'numerico') inputType = 'number';
            if (subcampo.tipo === 'fecha') inputType = 'date';
            return (
              <div key={idx} style={{ marginBottom: 8 }}>
                <label style={{ fontSize: '0.9em', marginRight: 6 }}>{subcampo.etiqueta}:</label>
                <input
                  type={inputType}
                  className="input is-small rulebuilder-glow"
                  value={subcampoValue}
                  onChange={e => handleSubcampoChange(subcampo.etiqueta, e.target.value)}
                  placeholder={`Ingrese ${subcampo.etiqueta}`}
                />
              </div>
            );
          })}
          <div style={{ marginTop: 4 }}>
            <span className="tag is-info is-light" style={{ fontSize: '0.85em' }}>
              Tipo de dato sugerido: <strong style={{ marginLeft: 4 }}>Compuesto</strong>
            </span>
          </div>
        </div>
      );
    }

    // Campos fijos: conviviente, relacion, genero
    if (["conviviente", "relacion", "genero"].includes(condicion.categoria)) {
      return (
        <div>
          <div className="select is-small">
            <select
              className="rulebuilder-glow"
              value={condicion.valor}
              onChange={(e) =>
                actualizarCondicion(condicion.id, "valor", e.target.value, parentId)
              }
            >
              <option value="">Seleccione...</option>
              {campos.map((op, idx) => (
                <option key={op.id || idx} value={op.id}>{op.Nombre}</option>
              ))}
            </select>
          </div>
          <div style={{ marginTop: 4 }}>
            <span className="tag is-info is-light" style={{ fontSize: '0.85em' }}>
              Tipo de dato sugerido: <strong style={{ marginLeft: 4 }}>Selección</strong>
            </span>
          </div>
        </div>
      );
    }

    // Adaptar input según tipo de dato
    let inputType = "text";
    let inputStep = undefined;
    let inputPlaceholder = "Ingrese un valor";

    if (tipo === TIPOS_DATO.NUMERICO) {
      inputType = "number";
      inputStep = "any";
      inputPlaceholder = "Ingrese un número";
    } else if (tipo === TIPOS_DATO.FECHA) {
      inputType = "date";
      inputPlaceholder = "Seleccione una fecha";
    } else if (tipo === TIPOS_DATO.BOOLEANO) {
      // Booleano: select sí/no
      return (
        <div>
          <div className="select is-small">
            <select
              className="rulebuilder-glow"
              value={condicion.valor}
              onChange={(e) => actualizarCondicion(condicion.id, "valor", e.target.value, parentId)}
            >
              <option value="">Seleccione...</option>
              <option value="true">Sí</option>
              <option value="false">No</option>
            </select>
          </div>
          <div style={{ marginTop: 4 }}>
            <span className="tag is-info is-light" style={{ fontSize: '0.85em' }}>
              Tipo de dato sugerido: <strong style={{ marginLeft: 4 }}>Booleano</strong>
            </span>
          </div>
        </div>
      );
    } else if ((tipo === TIPOS_DATO.SELECCION || tipo === TIPOS_DATO.MULTIPLE) && campoData?.json_definicion?.configuracion?.opciones?.length > 0) {
      // Selección única o múltiple: mostrar select con opciones
      if (tipo === TIPOS_DATO.MULTIPLE) {
        // Selección múltiple: select con multiple y array de valores
        return (
          <div>
            <div className="select is-small" style={{ width: '100%' }}>
              <select
                className="rulebuilder-glow"
                multiple
                value={Array.isArray(condicion.valor) ? condicion.valor : (condicion.valor ? [condicion.valor] : [])}
                onChange={(e) => {
                  const selected = Array.from(e.target.selectedOptions, option => option.value);
                  actualizarCondicion(condicion.id, "valor", selected, parentId);
                }}
                style={{ minHeight: '70px', width: '100%' }}
              >
                {campoData.json_definicion.configuracion.opciones.map((op, idx) => (
                  <option key={idx} value={op}>{op}</option>
                ))}
              </select>
            </div>
            <div style={{ marginTop: 4 }}>
              <span className="tag is-info is-light" style={{ fontSize: '0.85em' }}>
                Tipo de dato sugerido: <strong style={{ marginLeft: 4 }}>Selección múltiple</strong>
              </span>
            </div>
          </div>
        );
      } else {
        // Selección única
        return (
          <div>
            <div className="select is-small">
              <select
                className="rulebuilder-glow"
                value={condicion.valor}
                onChange={(e) => actualizarCondicion(condicion.id, "valor", e.target.value, parentId)}
              >
                <option value="">Seleccione...</option>
                {campoData.json_definicion.configuracion.opciones.map((op, idx) => (
                  <option key={idx} value={op}>{op}</option>
                ))}
              </select>
            </div>
            <div style={{ marginTop: 4 }}>
              <span className="tag is-info is-light" style={{ fontSize: '0.85em' }}>
                Tipo de dato sugerido: <strong style={{ marginLeft: 4 }}>Selección</strong>
              </span>
            </div>
          </div>
        );
      }
    } else if (tipo === TIPOS_DATO.COMPUESTO && campoData?.json_definicion?.configuracion?.subcampos?.length > 0) {
      // Campo compuesto: mostrar inputs para cada subcampo definido
      const valorCompuesto = typeof condicion.valor === 'object' && condicion.valor !== null ? condicion.valor : {};
      const subcampos = campoData.json_definicion.configuracion.subcampos;
      const handleSubcampoChange = (etiqueta, value) => {
        const nuevoValor = {
          ...valorCompuesto,
          [etiqueta]: value
        };
        actualizarCondicion(condicion.id, "valor", nuevoValor, parentId);
      };
      return (
        <div>
          {subcampos.map((subcampo, idx) => {
            const subcampoValue = valorCompuesto[subcampo.etiqueta] || '';
            let inputType = 'text';
            if (subcampo.tipo === 'numerico') inputType = 'number';
            if (subcampo.tipo === 'fecha') inputType = 'date';
            return (
              <div key={idx} style={{ marginBottom: 8 }}>
                <label style={{ fontSize: '0.9em', marginRight: 6 }}>{subcampo.etiqueta}:</label>
                <input
                  type={inputType}
                  className="input is-small rulebuilder-glow"
                  value={subcampoValue}
                  onChange={e => handleSubcampoChange(subcampo.etiqueta, e.target.value)}
                  placeholder={`Ingrese ${subcampo.etiqueta}`}
                />
              </div>
            );
          })}
          <div style={{ marginTop: 4 }}>
            <span className="tag is-info is-light" style={{ fontSize: '0.85em' }}>
              Tipo de dato sugerido: <strong style={{ marginLeft: 4 }}>Compuesto</strong>
            </span>
          </div>
        </div>
      );
    }

    return (
      <div>
        <input
          type={inputType}
          step={inputStep}
          className="input is-small rulebuilder-glow"
          value={condicion.valor}
          onChange={(e) =>
            actualizarCondicion(condicion.id, "valor", e.target.value, parentId)
          }
          placeholder={inputPlaceholder}
        />
        <div style={{ marginTop: 4 }}>
          <span className="tag is-info is-light" style={{ fontSize: '0.85em' }}>
            Tipo de dato sugerido: <strong style={{ marginLeft: 4 }}>{
              tipo === TIPOS_DATO.NUMERICO ? 'Numérico' :
              tipo === TIPOS_DATO.FECHA ? 'Fecha' :
              tipo === TIPOS_DATO.TEXTO ? 'Texto' :
              tipo === TIPOS_DATO.DURACION ? 'Duración' :
              tipo === TIPOS_DATO.SELECCION ? 'Selección' :
              tipo === TIPOS_DATO.MULTIPLE ? 'Selección múltiple' :
              tipo
            }</strong>
          </span>
        </div>
      </div>
    );
  };

  const renderCondicion = (condicion, index, parentId = null) => {
    const campos = obtenerCamposPorCategoria(condicion.categoria);
    const tipo = condicion.campo ? obtenerTipoDato(condicion.categoria, condicion.campo) : null;
    const operadores = tipo ? obtenerOperadoresPorTipo(tipo) : [];

    console.log("Renderizando condición:", { 
      id: condicion.id,
      categoria: condicion.categoria, 
      campo: condicion.campo,
      valor: condicion.valor,
      campos: campos.length,
      todaLaCondicion: condicion
    });

    return (
      <div key={condicion.id} className="box" style={{ marginBottom: "10px", padding: "15px" }}>
        {/* Operador lógico entre condiciones (solo si no es la primera) */}
        {index > 0 && (
          <div style={{ marginBottom: 8 }}>
            <div className="select is-small">
              <select
                value={condicion.operadorLogico}
                onChange={(e) =>
                  actualizarCondicion(condicion.id, "operadorLogico", e.target.value, parentId)
                }
              >
                <option value="AND">Y</option>
                <option value="OR">O</option>
              </select>
            </div>
          </div>
        )}
        {/* Categoría */}
        <div style={{ marginBottom: 8 }}>
          <div className="select is-small" title="Seleccione la categoría del dato a evaluar" style={{ width: '100%' }}>
            <select
              value={condicion.categoria}
              onChange={(e) => {
                actualizarCondicion(condicion.id, "categoria", e.target.value, parentId);
                actualizarCondicion(condicion.id, "campo", "", parentId);
                actualizarCondicion(condicion.id, "valor", "", parentId);
              }}
              style={{ width: '100%' }}
            >
              <option value="" disabled>Seleccione categoría...</option>
              <option value="sintoma">Síntoma (ej: fiebre, tos)</option>
              <option value="estudio">Estudio (ej: radiografía, PCR)</option>
              <option value="talle">Talle (altura)</option>
              <option value="peso">Peso (kg)</option>
              <option value="vacuna">Vacuna (aplicada)</option>
              <option value="comorbilidad">Comorbilidad (enfermedad previa)</option>
              <option value="atributo">Atributo Personal (característica)</option>
              <option value="conviviente">Conviviente (¿vive con el caso?)</option>
              <option value="relacion">Relación con el caso</option>
              <option value="genero">Género (identidad)</option>
            </select>
          </div>
          <small className="has-text-grey" style={{ fontSize: '0.85em' }}>¿Qué tipo de dato desea evaluar?</small>
        </div>
        {/* Campo */}
        <div style={{ marginBottom: 8 }}>
          <div className="select is-small" title="Seleccione el campo específico dentro de la categoría elegida" style={{ width: '100%' }}>
            <select
              value={condicion.campo}
              onChange={(e) => {
                actualizarCondicion(condicion.id, "campo", e.target.value, parentId);
                actualizarCondicion(condicion.id, "valor", "", parentId);
              }}
              disabled={!condicion.categoria}
              style={{ width: '100%' }}
            >
              <option value="">Seleccione un campo...</option>
              {campos.length === 0 && (
                <option value="" disabled>No hay campos disponibles</option>
              )}
              {campos.map((campo) => {
                let id, nombre;
                if (condicion.categoria === "relacion") {
                  id = (campo.Nombre || campo.nombre || campo.NombreRelacion || campo.Descripcion || campo.descripcion || campo.Tipo || campo.tipo || "(Sin nombre)").trim();
                  nombre = id;
                } else {
                  switch (condicion.categoria) {
                    case "sintoma":
                      id = campo.IdSintomaPorPatologia;
                      nombre = campo.NombreSintoma || campo.Nombre;
                      break;
                    case "estudio":
                      id = campo.IdEstudio;
                      nombre = campo.Nombre;
                      break;
                    case "medicacion":
                      id = campo.IdMedicacionPorPatologia;
                      nombre = campo.NombreMedicacion || campo.Nombre;
                      break;
                    case "vacuna":
                      id = campo.IdVacunacionPorPatologia;
                      nombre = campo.NombreVacuna || campo.Nombre;
                      break;
                    case "comorbilidad":
                      id = campo.IdComorbilidad;
                      nombre = campo.Nombre;
                      break;
                    case "atributo":
                      id = campo.IdAtributo;
                      nombre = campo.NombreAtributo || campo.Nombre;
                      break;
                    case "talle":
                      id = "datosAntropometricos.talla";
                      nombre = campo.Nombre;
                      break;
                    case "peso":
                      id = "datosAntropometricos.peso";
                      nombre = campo.Nombre;
                      break;
                    default:
                      id = campo.id;
                      nombre = campo.Nombre;
                  }
                }
                return (
                  <option key={id} value={id}>
                    {nombre}
                  </option>
                );
              })}
            </select>
          </div>
          <small className="has-text-grey" style={{ fontSize: '0.85em' }}>¿Qué campo de la categoría desea evaluar?</small>
        </div>
        {/* Operador */}
        <div style={{ marginBottom: 8, width: '100%' }}>
          <div className="select is-small" title="Seleccione el operador lógico para comparar" style={{ width: '100%' }}>
            <select
              value={condicion.operador}
              onChange={(e) =>
                actualizarCondicion(condicion.id, "operador", e.target.value, parentId)
              }
              disabled={!condicion.campo}
              style={{ width: '100%' }}
            >
              <option value="" disabled>Operador...</option>
              {operadores.map((op) => (
                <option key={op.value} value={op.value}>
                  {op.label}
                </option>
              ))}
            </select>
          </div>
          <small className="has-text-grey" style={{ fontSize: '0.85em', display: 'block', marginTop: 2, whiteSpace: 'normal', lineHeight: 1.1 }}>¿Cómo se compara el valor?</small>
        </div>
        {/* Valor */}
        <div style={{ marginBottom: 8, width: '100%' }}>
          {renderInputValor(condicion, parentId)}
        </div>
        {/* Botón eliminar */}
        <div>
          <button
            className="button is-small is-danger"
            onClick={() => eliminarCondicion(condicion.id, parentId)}
            title="Eliminar condición"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </div>
      </div>
    );
  };

  const renderGrupoCondiciones = (grupo, index) => {
    return (
      <div
        key={grupo.id}
        className="box"
        style={{
          backgroundColor: "#f5f5f5",
          border: "2px solid #dbdbdb"
        }}
      >
        <div className="columns">
          <div className="column">
            <strong>Grupo de Condiciones</strong>
          </div>
          {index > 0 && (
            <div className="column is-narrow">
              <div className="select is-small">
                <select
                  value={grupo.operadorLogico}
                  onChange={(e) =>
                    actualizarCondicion(grupo.id, "operadorLogico", e.target.value)
                  }
                >
                  <option value="AND">Y</option>
                  <option value="OR">O</option>
                </select>
              </div>
            </div>
          )}
          <div className="column is-narrow">
            <button
              className="button is-small is-danger"
              onClick={() => eliminarCondicion(grupo.id)}
              title="Eliminar grupo"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        </div>

        <div style={{ marginLeft: "20px", marginTop: "10px" }}>
          {grupo.condiciones.map((cond, idx) => renderCondicion(cond, idx, grupo.id))}

          <button
            className="button is-small is-info"
            onClick={() => agregarCondicionAGrupo(grupo.id)}
          >
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: "5px" }} />
            Añadir Condición al Grupo
          </button>
        </div>
      </div>
    );
  };

  const handleSave = () => {
    if (!nombre.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Campo requerido",
        text: "Debe ingresar un nombre para la regla.",
      });
      return;
    }

    if (condiciones.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Sin condiciones",
        text: "Debe agregar al menos una condición.",
      });
      return;
    }

    if (!mensaje.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Campo requerido",
        text: "Debe ingresar un mensaje de alerta.",
      });
      return;
    }

    // Validar que todas las condiciones estén completas
    const validarCondiciones = (conds) => {
      for (const cond of conds) {
        if (cond.tipo === "grupo") {
          if (!validarCondiciones(cond.condiciones)) return false;
        } else {
          if (!cond.campo || !cond.operador || cond.valor === "") {
            return false;
          }
        }
      }
      return true;
    };

    if (!validarCondiciones(condiciones)) {
      Swal.fire({
        icon: "warning",
        title: "Condiciones incompletas",
        text: "Todas las condiciones deben estar completas.",
      });
      return;
    }

    // --- Refactor: transformación por categoría ---
    // Handler para vacunas
    const transformarCondicionVacuna = (cond) => {
      return {
        ...cond,
        campoOriginal: cond.campo,
        campo: `vacunas.${cond.campo}`,
        valor: cond.valor
      };
    };

    // Handler para síntomas
    const transformarCondicionSintoma = (cond) => {
      return {
        ...cond,
        campoOriginal: cond.campo,
        campo: `sintomas.${cond.campo}`,
        valor: cond.valor
      };
    };

    // Handler para estudios
    const transformarCondicionEstudio = (cond) => {
      return {
        ...cond,
        campoOriginal: cond.campo,
        campo: `estudios.${cond.campo}`,
        valor: cond.valor
      };
    };

    // Handler para medicaciones
    const transformarCondicionMedicacion = (cond) => {
      return {
        ...cond,
        campoOriginal: cond.campo,
        campo: `medicaciones.${cond.campo}`,
        valor: cond.valor
      };
    };

    // Handler para comorbilidades
    const transformarCondicionComorbilidad = (cond) => {
      return {
        ...cond,
        campoOriginal: cond.campo,
        campo: `comorbilidades.${cond.campo}`,
        valor: (cond.valor === true || cond.valor === 'true' || cond.valor === 1 || cond.valor === '1') ? 'true' : 'false'
      };
    };

    // Handler para atributos
    const transformarCondicionAtributo = (cond) => {
      return {
        ...cond,
        campoOriginal: cond.campo,
        campo: `atributos.${cond.campo}`,
        valor: (cond.valor === true || cond.valor === 'true' || cond.valor === 1 || cond.valor === '1') ? 'true' : 'false'
      };
    };

    // Handler para talle
    const transformarCondicionTalle = (cond) => {
      return {
        ...cond,
        campoOriginal: cond.campo,
        campo: "datosAntropometricos.talla",
        valor: cond.valor
      };
    };

    // Handler para peso
    const transformarCondicionPeso = (cond) => {
      return {
        ...cond,
        campoOriginal: cond.campo,
        campo: "datosAntropometricos.peso",
        valor: cond.valor
      };
    };

    // Handler para conviviente
    const transformarCondicionConviviente = (cond) => {
      let valorFinal;
      if (typeof cond.valor === 'string') {
        if (cond.valor.trim().toLowerCase() === 'si' || cond.valor.trim().toLowerCase() === 'sí') {
          valorFinal = 'Sí';
        } else if (cond.valor.trim().toLowerCase() === 'no') {
          valorFinal = 'No';
        } else {
          valorFinal = cond.valor;
        }
      } else {
        valorFinal = cond.valor;
      }
      return {
        ...cond,
        campoOriginal: cond.campo,
        campo: "conviviente",
        valor: valorFinal
      };
    };

    // Handler para relacion
    const transformarCondicionRelacion = (cond) => {
      return {
        ...cond,
        campoOriginal: cond.campo,
        campo: `relacion.${cond.campo}`,
        valor: cond.valor
      };
    };

    // Handler para genero
    const transformarCondicionGenero = (cond) => {
      let campoCompleto;
      if (cond.campo === "contacto.genero") {
        campoCompleto = "contacto.genero";
      } else {
        campoCompleto = "genero";
      }
      return {
        ...cond,
        campoOriginal: cond.campo,
        campo: campoCompleto,
        valor: cond.valor
      };
    };

    // Handler para edad
    const transformarCondicionEdad = (cond) => {
      let campoCompleto;
      if (cond.campo === "contacto.edad") {
        campoCompleto = "contacto.edad";
      } else {
        campoCompleto = "edad";
      }
      return {
        ...cond,
        campoOriginal: cond.campo,
        campo: campoCompleto,
        valor: cond.valor
      };
    };

    // Dispatcher por categoría
    const transformarCondicionPorCategoria = (cond) => {
      switch (cond.categoria) {
        case "vacuna":
          return transformarCondicionVacuna(cond);
        case "sintoma":
          return transformarCondicionSintoma(cond);
        case "estudio":
          return transformarCondicionEstudio(cond);
        case "medicacion":
          return transformarCondicionMedicacion(cond);
        case "comorbilidad":
          return transformarCondicionComorbilidad(cond);
        case "atributo":
          return transformarCondicionAtributo(cond);
        case "talle":
          return transformarCondicionTalle(cond);
        case "peso":
          return transformarCondicionPeso(cond);
        case "conviviente":
          return transformarCondicionConviviente(cond);
        case "relacion":
          return transformarCondicionRelacion(cond);
        case "genero":
          return transformarCondicionGenero(cond);
        case "edad":
          return transformarCondicionEdad(cond);
        default:
          return { ...cond };
      }
    };

    // Nueva función principal
    const transformarCondiciones = (conds) => {
      return conds
        .filter(cond => {
          // Filtrar grupos vacíos
          if (cond.tipo === "grupo" && (!cond.condiciones || cond.condiciones.length === 0)) {
            console.warn('Grupo vacío eliminado durante la transformación');
            return false;
          }
          return true;
        })
        .map(cond => {
          if (cond.tipo === "grupo") {
            return {
              ...cond,
              condiciones: transformarCondiciones(cond.condiciones)
            };
          } else {
            return transformarCondicionPorCategoria(cond);
          }
        });
    };

        // export default RuleBuilder; // <-- Remove misplaced export
    // Asegurar que el mensaje esté definido y limpio
    const mensajeFinal = typeof mensaje === 'string' && mensaje.trim() !== '' ? mensaje.trim() : 'Alerta sin mensaje';
    const ruleData = {
      Nombre: nombre,
      Descripcion: descripcion,
      Json_Definicion: {
        condiciones: transformarCondiciones(condiciones),
        mensaje: mensajeFinal,
      },
    };

    onSave(ruleData);
  };

  return (
    <div>
      <div className="field">
        <label className="label">Nombre de la Regla *</label>
        <div className="control">
          <input
            className="input"
            type="text"
            placeholder="Ej: Sospecha de COVID-19"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
          />
        </div>
      </div>

      <div className="field">
        <label className="label">Descripción</label>
        <div className="control">
          <textarea
            className="textarea"
            placeholder="Descripción opcional de la regla"
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
            rows="2"
          />
        </div>
      </div>

      <div className="field">
        <label className="label">Mensaje de Alerta *</label>
        <div className="control">
          <textarea
            className="textarea"
            placeholder="Mensaje que se mostrará cuando se cumpla la condición"
            value={mensaje}
            onChange={(e) => setMensaje(e.target.value)}
            rows="3"
          />
        </div>
        <p className="help">Este mensaje aparecerá en el popup cuando la regla se active.</p>
      </div>

      <hr />

      <div className="field">
        <label className="label">Condiciones de la Regla</label>
        <div className="buttons">
          <button className="button is-primary is-small" onClick={agregarCondicion}>
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: "5px" }} />
            Añadir Condición
          </button>
          <button className="button is-info is-small" onClick={agregarGrupoCondiciones}>
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: "5px" }} />
            Añadir Grupo de Condiciones
          </button>
        </div>
      </div>

      <div style={{ marginTop: "20px" }}>
        {condiciones.map((cond, index) =>
          cond.tipo === "grupo"
            ? renderGrupoCondiciones(cond, index)
            : renderCondicion(cond, index)
        )}
      </div>

      {condiciones.length === 0 && (
        <div className="notification is-info is-light">
          <p>No hay condiciones agregadas. Haga clic en "Añadir Condición" para comenzar.</p>
        </div>
      )}
      <div className="field is-grouped">
        <div className="control">
          <button className="button is-primary" onClick={handleSave}>
            {editingRule ? "Actualizar Regla" : "Guardar Regla"}
          </button>
        </div>
        <div className="control">
          <button className="button is-light" onClick={onCancel}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default RuleBuilder;

